// extracted by mini-css-extract-plugin
export default {"card":"S0-z","carouselContainer":"T0-z","carouselContent":"U0-z"};